import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useShowPrompt } from 'civic-champs-shared/core/modal/hooks'
import ConfirmLeaveQuestionnaireDialog from 'surveys/components/ConfirmLeaveQuestionnaireDialog'

export const useQuestionnaireUnsavedChangesGuard = (isDirty: boolean, enabled: boolean) => {
  const history = useHistory()
  const showLeaveDialog = useShowPrompt(ConfirmLeaveQuestionnaireDialog)

  useEffect(() => {
    if (!enabled || !isDirty) {
      return
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      event.returnValue = ''
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    let unblock = history.block((location, action) => {
      showLeaveDialog().then(leave => {
        if (leave) {
          unblock()
          if (action === 'POP') {
            history.goBack()
          } else {
            history.push(`${location.pathname}${location.search}${location.hash}`)
          }
        }
      })
      return false
    })

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
      unblock()
    }
  }, [enabled, history, isDirty, showLeaveDialog])
}

export default useQuestionnaireUnsavedChangesGuard
